import React from 'react';

// Styles
import {blueColor, greyishBlue500} from "assets/jss/main";
import {FormattedMessage} from "react-intl";

function NoValidateProducts() {
    return (
        <div
            style={{
                padding: '24px 16px',
                textAlign: 'center'
            }}
        >
            <p
                style={{
                    fontSize: '14px',
                    color: blueColor,
                    fontWeight: 600,
                    marginBottom:'32px'
                }}
            >
                <FormattedMessage id={'wms.myPickingMissions.product.validated.empty.title'} />
            </p>
            <div style={{ paddingLeft: '40px', paddingRight: '40px', textAlign: 'center' }}>
                <span style={{fontSize: '32px'}}>🔎</span>
                <p
                    style={{
                        fontSize: '14px',
                        color: greyishBlue500
                    }}
                >
                    <FormattedMessage id={'wms.myPickingMissions.product.validated.empty.subtitle'} />
                </p>
            </div>
        </div>
    );
}

export default NoValidateProducts;
